import React, { useRef, useEffect, useState } from "react";
import video from "../../assets/drone_video.mp4"
import poster from "../../assets/images/poster.jpg"
export default function Video() {
  const iframeRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
        console.log("In view:", entry.isIntersecting); // debug log
      },
      { threshold: 0.5 }, // triggers when 50% of section is visible
    );

    if (iframeRef.current) {
      observer.observe(iframeRef.current);
    }

    return () => {
      if (iframeRef.current) {
        observer.unobserve(iframeRef.current);
      }
    };
  }, []);


  return (
   
      <div
        ref={iframeRef}
        style={{
        
          overflow: "hidden",
        }} className="bg-[#fdf6f6] xl:pb-16 pb-10"
      >
        <div className="text-center my-8 xl:my-12">
          <h2 className="font-crimson text-3xl xl:text-5xl pb-5 text-[#5e3920]">
            A Closer Look at Flats in Patancheru
          </h2>
          <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 px-4 xl:text-[18px] font-inter leading-relaxed">
            Take a closer look at Aura by Tranquillo and explore the 2 BHK homes, community spaces and lifestyle features planned within the project.
          </p>
        </div>
        <div className="mx-auto w-11/12 ">
        <video poster={poster} className="w-full h-full" title="A Closer Look at Flats in Patancheru"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{ display: "block" }} controls 
          src={video} />
        </div>
      </div>
 
  );
}
